export default "__VITE_ASSET__cF7qEHFc__";